import { AgencyMasterProperties } from "./AgencyMasterProperties";
import { UsersProperties } from "./UsersProperties";


export class ImportPnrDetails {
  isImport: boolean;
  errorMsg: string;
  alreadyPriced: boolean;
  airPricingSolution: string;
  importPnrAgencyDetailsInfo= new ImportPnrAgencyDetails();
  importPassengerPnrInfo: ImportPnrPassengerDetailsProperties[] = [];
  sectorInformation: ImportPnrSectorInfoProperties[] = [];
  taxDetails: ImportPnrTaxDetailsProperties[] = [];
  fareDetails = new ImportPnrfareDetailsProperties();
  agencyOnline = new AgencyMasterProperties();
  userOnline = new UsersProperties();
  totalNetAmount: string;
  parentHierarchy: string;
  userBackSystemCompanyId: number;
  userBackSystemCustomer: string;
  isOfflineRequest: boolean;
}
export class ImportPnrAgencyDetails {
  importID: number;
  providerCode: string;
  importAgency: string;
  requestingAgency: string;
  pnr: string;
  supplierPNR: string;
  importUser: number;
  importDateTime: string;
  ticketIssuanceDateTime: string;
  modifiedDateTime: string;
  importRefrenceNumber: string;
  status: boolean;
  isDeleted: boolean;
}
export class ImportPnrSectorInfoProperties {
  id: number;
  importPNR_PassengerID: number;
  modifiedDateTime: string;
  fromAirport: string;
  toAirport: string;
  fromAirportName: string;
  toAirportName: string;
  rbd: string;
  cabinClass: string;
  airlineCode: string;
  operatingAirlineCode: string;
  validatingAirlineCode: string;
  glightNo: string;
  flightStatus: string;
  departureDate: string;
  departureTime: string;
  arrivalDate: string;
  arrivalTime: string;
  fareBasisCode: string;
  aircraft: string;
  stopOverIndicator: string;
  noOfStops: number;
  StopsAt: string;
  departureTerminal: string;
  arrivalTerminal: string;
  flownMile: string;
  ticketDesignator: string;
  frequentFlyerNo: string;
  frequentFlyerMiles: string;
  segmentValue: string;
  fuelSurchargeAmount: string;
  currencyCode: string;
  baggageCheckIn: string;
  baggageCabin: string;
  isDeleted: boolean;
  isRefunded: boolean;
  refundId: number;
  fromICAO: string;
  fromCity: string;
  fromCountry: string;
  toCity: string;
  toCountry: string;
  toICAO: string;
  airlineLogo: string;
  airlineLegalName: string;
}
export class ImportPnrTaxDetailsProperties {
  taxID: number;
  importPNR_PassengerID: number;
  taxType: string;
  taxAmount: string;
  refundTaxAmount: string;
  isDeleted: boolean;
  isRefund: boolean;
  refundID: number;
}
export class ImportPnrPassengerDetailsProperties {

  passengerType: number;
  passengerID: number;
  title: string;
  profile_Id: number;
  frequent_Flyer_No: string;
  passengerName: string;
  firstName: string;
  firstNameShow: string;
  lastName: string;
  prefix: string;
  pAXGender: string;
  paxdob: string;
  paxNationality: string;
  pAXIsLead: boolean;
  passportNumber: string;
  countryOfIssuance: string;
  passportValidFrom: string;
  passportValidTo: string;
  serviceType: number;
  serviceSubType: number;
  mobile: string;
  phone: string;
  email: string;
  pnr_Doc: string;
  ticketNo: string;
  tktBookingDate: string;
  travelingDate: string;
  sector: string;
  supplierCode: string;
  iATACode: number;
  airlineCode: string;
  tripType: string;
  conj_Option: string;
  conj_TktNo: string;
  exchange_TktNo: string;
  exchange_Option: string;
  exchange_TktFee: string;
  debitStatus: number;
  paymentMode: number;
  bookingID: number;
  issuanceID: string;
  bookingPccCode: string;
  issuancePccCode: string;
  ItineraryNo: string;
  iATAInvoiceNo: string;
  mainSupplierID: string;
  sellerID: string;
  buyerID: string;
  costFromAmount: string;
  costFromCurrency: string;
  costExchangeRate: string;
  baseCurrency: string;
  exchangeCurrency: string;
  baseFare: string;
  totalTaxes: string;
  markup: string;
  netFromCustomer: string;
  netToSupplier: string;
  region: string;
  importID: number;
  modifiedDateTime: string;
  supplierRemarks: string;
  isVoid: boolean;
  isRefund: boolean;
  isOfflineRefund: boolean;
  isOfflineVoid: boolean;
  refundAmount: string;
  netRefundAmount: string;
  refundServiceCharges: string;
  runtimeMarkup: string;
  airlineVoidCharges: string;
  agentVoidCharges: string;
  reasonForVoid: string;
  venderServiceCharges: string;
  supplierCommission: string;
  supplierVatInput: string;
  customerVatInput: string;
  vatInput: string;
  customerVatOutput: string;
  supplierVatOutput: string;
  vatOutput: string;
  serviceCharges: string;
  discount: string;
  additionalServiceCharges: string;
  commissionOffer: string;
  profit: string;
  visaApplicationNumber: number;
  roundingDiff: string;
  originDestinationDetails: string;
  psType: string;
  importPnrSectorInformationProperties: ImportPnrSectorInfoProperties[] = [];
  importPnrtaxesDetailsProperties: ImportPnrTaxDetailsProperties[] = [];
  bookingTravelerKey: string;
}

export class ImportPnrfareDetailsProperties {
  adultfare = new AdultFaresProperties();
  childfare = new ChildFaresProperties();
  infantfare = new InfantFaresProperties();
}
export class InfantFaresProperties {

  paxtype: string;
  paxcount: number;
  basefare: number = 0;
  totaltaxes: number = 0;
  serviceCharges: number = 0;
  netTotal: number = 0;
  discount: number = 0;
  basecurrency: string;
}
export class ChildFaresProperties {

  paxtype: string;
  paxcount: number;
  basefare: number = 0;
  totaltaxes: number = 0;
  serviceCharges: number = 0;
  netTotal: number = 0;
  discount: number = 0;
  basecurrency: string;
}
export class AdultFaresProperties {

  paxtype: string;
  paxcount: number;
  basefare: number = 0;
  totaltaxes: number = 0;
  serviceCharges: number = 0;
  netTotal: number = 0;
  discount: number = 0;
  basecurrency: string;
}



export class ImportPNRIssuanceResponse {
  isIssued: boolean;
  isPriceChanged: boolean;
  oldPrice: string;
  newPrice: string;
  airPricingSolution: string;

  errorMsg: string;
  importPNRID: number;

}


export class ImportPnrListProperties {
  importID: number;
  providerCode: string;
  agency: string;
  pnr: string;
  sector: string;
  paxName: string;
  ticketNo: string;
  importDateTime: string;
  travelingDate: string;
  status: boolean;
  isOfflineParked: boolean;    //new added
}

//new added
export class ImportPNRListProperties {
  importID: number;
  pnr: string;
  supplier: string;
  tkt: string;
  name: string;
  trip: string;
  travelDate: string;
  importDate: string;
  importStatus: string;
  agencyId: string;
  requestTypeName: string;
  offlineImportId: string;
  offlineagencyId: string;
  amount: number;
  loginName: string;

  groupTicketId: number = 0;

}
export class ImportRequest {
  importAgency: string;
  pnr: string;
  bookingPccCode: string = "";
  importUser: number;
  parentHierarchy: string;
}



export class ImportPNREntryProprties {
  importPNREntryID: number;
  pcc: string;
  entry: string;
  airline: string;
  supplier: string;
  agencyId: string;
  userId: number;
  isDeleted: boolean;
}



